export enum OrderSortOption {
  ORDER_DATE_CLOSEST = "Order Date (Closest)",
  ORDER_DATE_FURTHEST = "Order Date (Furthest)",
  DUE_DATE_CLOSEST = "Due Date (Closest)",
  DUE_DATE_FURTHEST = "Due Date (Furthest)",
}
